import {
  Col,
  Container,
  Modal as ReactModal,
  Row,
  Spinner,
} from "react-bootstrap";

import "./modalStyles.css";

const Modal = ({
  size,
  imageTitle,
  title,
  address,
  bodyContent,
  showFooter,
  showButtonFooter,
  buttonFooterLabel,
  buttonFooterOnPress,
  buttonFooterDisabled,
  footerLabel,
  displayModal,
  setDisplayModal,
  isLoading = false,
}) => (
  <ReactModal
    size={size}
    show={displayModal}
    onHide={() => setDisplayModal(false)}
    centered
  >
    <ReactModal.Header closeButton className="geo-modal-header">
      <Row className="align-items-center w-100">
        <Col xs={7}>
          <ReactModal.Title className="geo-modal-title ml-2">
            {imageTitle && (
              <img src={imageTitle} alt="img-title" className="mr-2" />
            )}
            {title}
          </ReactModal.Title>
        </Col>
        <Col className="address-col text-right">
          {address && <span className="address">{address}</span>}
        </Col>
      </Row>
    </ReactModal.Header>
    <ReactModal.Body className="geo-modal-body">{bodyContent}</ReactModal.Body>
    {showFooter && (
      <ReactModal.Footer className="geo-modal-footer">
        <Container>
          {showButtonFooter && (
            <Row>
              <Col xs={12}>
                <button
                  className="geo-modal-footer-button mx-auto w-100"
                  disabled={buttonFooterDisabled}
                  onClick={buttonFooterOnPress}
                >
                  {isLoading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    buttonFooterLabel
                  )}
                </button>
              </Col>
            </Row>
          )}
          <Row className="justify-content-center">
            <p className="geo-modal-footer-text text-center">{footerLabel}</p>
          </Row>
        </Container>
      </ReactModal.Footer>
    )}
  </ReactModal>
);

export default Modal;
